import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation DeleteHoliday($id: Int!) {
    deleteHoliday(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deleteHoliday: {
    id?: number;
  };
}
